/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerFindAllQueryResponse, ApplicationSummariesControllerFindAllQueryParams, ApplicationSummariesControllerFindAll401, ApplicationSummariesControllerFindAll403 } from "../../models/checklistsController/ApplicationSummariesControllerFindAll";

function getApplicationSummariesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-application-summaries` as const }  
  return res
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist application summaries
 * {@link /api/v1/checklist-application-summaries}
 */
export async function applicationSummariesControllerFindAll(params?: ApplicationSummariesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSummariesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindAll401 | ApplicationSummariesControllerFindAll403>, unknown>({ method : "GET", url : getApplicationSummariesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}